import tw from "twrnc";

// Design tokens for the event settings screens (docs/event-settings-ui.md).
// Screens use the components in this folder rather than these values directly;
// scripts/settings-ui-check.mjs keeps ad-hoc sizes and colours out of them.

export const colors = {
  brand: "#F84123", // primary buttons, active menu item, text links
  brandPressed: "#DE3517",
  brandTint: "#FFEDE9", // active menu item, selected cards
  brandBorder: "#FBD5CC", // border of a selected (brand-tinted) card
  ink: "#2E3F52", // titles, labels and body text
  slate: "#3F5B7A", // secondary buttons, icons, selected segments
  muted: "#6B7280", // descriptions and hints
  subtle: "#9CA3AF", // help icon, placeholders, disabled text
  border: "#D1D5DB", // inputs and cards
  divider: "#E5E7EB", // between rows
  surface: "#F9FAFB", // panels and list cards
  surfaceStrong: "#F3F4F6",
  pressOverlay: "rgba(46, 63, 82, 0.08)", // icon buttons on hover/press, on any card
  focus: "#3B82F6",
  disabledBg: "#E5E7EB",
  danger: "#DC2626",
  dangerTint: "#FEF2F2",
  success: "#15803D",
  successTint: "#F0FDF4",
  warning: "#92400E",
  warningTint: "#FFFBEB",
  info: "#1E3A8A",
  infoTint: "#EFF6FF",
  tooltip: "#2E3F52", // tooltips and toasts: one dark surface everywhere
  tooltipHover: "#24323F", // a clickable tooltip under the pointer
  tooltipLink: "#FFB4A5",
  white: "#FFFFFF",
};

// Guest status pills (white text on these passes WCAG AA).
export const statusColors = {
  joinedLive: "#15803D",
  watchedReplay: "#166534",
  visited: "#4B5563",
  invited: "#1D4ED8",
};

// Type scale. Body copy is 14px everywhere in settings, hints 13px.
export const text = {
  pageTitle: tw`text-[24px] leading-[30px] font-bold text-[${colors.ink}]`,
  sectionTitle: tw`text-[18px] leading-[24px] font-bold text-[${colors.ink}]`,
  label: tw`text-[14px] leading-[20px] font-semibold text-[${colors.ink}]`,
  body: tw`text-[14px] leading-[20px] text-[${colors.ink}]`,
  bodyStrong: tw`text-[14px] leading-[20px] font-semibold text-[${colors.ink}]`,
  hint: tw`text-[13px] leading-[18px] text-[${colors.muted}]`,
  error: tw`text-[13px] leading-[18px] text-[${colors.danger}]`,
  link: tw`text-[14px] leading-[20px] font-semibold text-[${colors.brand}]`,
  modalTitle: tw`text-[20px] leading-[26px] font-bold text-[${colors.ink}]`,
};

// Spacing (4px grid).
export const space = {
  labelGap: 6, // label → control, control → hint
  field: 16, // between fields
  sectionTitleGap: 12, // section title (and description) → first field
  section: 32, // between sections
  pageHeader: 24, // page title (and description) → first section
  buttonGap: 12, // between stacked buttons
};

export const radius = { control: 8, card: 12, pill: 999 };

// Heights of inputs and buttons.
export const control = { lg: 48, md: 40, sm: 32 };

// The settings column: every settings screen uses the same width.
export const CONTENT_MAX_WIDTH = 576;
